import { cleanName } from "@/lib/utils/nameUtils";

// Add full names here only.
// Profile id is auto-generated from the cleaned name:
// "Ali Monam" -> "alimonam"
export const SPECIAL_PROFILE_BYPASS_NAMES = [
  "Ali Monam",
  "Neda Ghazi",
];

const normalizePersonQuery = (input) =>
  cleanName(input || "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .replace(/\s+/g, " ");

export const findSpecialProfileRedirect = (input) => {
  const normalized = normalizePersonQuery(input);
  if (!normalized) return null;

  for (const fullName of SPECIAL_PROFILE_BYPASS_NAMES) {
    const normalizedName = normalizePersonQuery(fullName);
    if (!normalizedName) continue;

    // Match if query contains the full name anywhere, e.g. "Ali Monam at Meex".
    if (normalized.includes(normalizedName)) {
      return normalizedName.replace(/\s+/g, "");
    }
  }

  return null;
};
